import { useState, useEffect, useContext } from "react";
import { Census_func } from "../../../api/devices/census/census_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem, TooltipHost } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Tooltip, Input, ButtonProps } from "@fluentui/react-components";
import { PulseSquare20Regular, AppsAddIn20Regular, BoxCheckmark20Regular, UninstallApp20Regular, CheckboxCheckedSync20Regular, SquareHintApps20Regular, ShieldLock20Regular, BookTemplate20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, SlideEraser20Regular, Copy20Regular, AddSquare20Regular, Dismiss16Regular, ArrowMaximize20Regular, DismissSquare24Filled, FilterAdd20Filled } from "@fluentui/react-icons";
import { SearchBox } from "@fluentui/react-search-preview";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { Resize } from "../../../components/textarea/textarea.component";
import { Checked } from "../../../components/switch/switch.component";
import { CheckBox } from "../../../components/checkbox/checkbox_component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { DynamicBoxingCSS, exitIcon, fullscreenIcon, heightResponsive, lightTheme, dashboardTheme, overflowDivider, parentHome, primaryIcon, secondaryIcon, SubSectionResponsive, BreadcrumbsBorder, wraperStyle } from "../../../styles/customStyles";
import { GlobalContext } from "../../../hooks/globalContext";
import { SkeletonContent } from "../../../components/skeleton/skeletonContent";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";


const handleExportCSV = () => {
  // Programmatically trigger the CSV export link
  const csvExportLink = document.getElementById('csv-export-link');
  if (csvExportLink) {
    csvExportLink.click();
  }
};

export const Discoveredapps_list = () => {
  const navigate = useNavigate();

  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  const handle = useFullScreenHandle();
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [isfilter, setIsFilter]: any = useState(false);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [response, setresponse] = useState('');
  const [refreshing, setRefreshing] = useState(false);
  const { permissions } = usePermissionStore();
  console.log("checking the permissions------>", permissions)

  const handleRefresh = () => {
    setRefreshing(true);
  };


  const handleFilterArray = (): any => {
    const value1 = dropDownValue1
    const value2 = dropDownValue2;
    if (value1 !== undefined && value1 !== '' && value2 !== undefined && value2 !== '') {
      const result = value1 + " : " + value2;
      setFilterArray([...filterArray, result])
      setIsFilter(true);
    }
  }
  const handleCloseFilter = (index: any): any => {
    console.log("cllciked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
  }
  const [isIconEnabled, setIconEnabled] = useState(false);
  const handleIconActive: any = (data: any) => {
    setIconEnabled(data.target.checked);
  }

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    if (name === 'filter') {
      setDropDownValue2(enteredValue);
    }
  }

  var menuItems: any = [];

  if (permissions.includes("all") || permissions.includes("discoverApps_Read") || permissions.includes("discoverApps_Fullaccess") || permissions.includes("discoverApps_ReadandExport")) {
    menuItems.push
      (
        <FluentProvider theme={lightTheme}>
          <MenuItem onClick={() => navigate("/manage/apps/discoveredapps")} icon={
            <Stack horizontal tokens={{ childrenGap: 40 }}>
              <StackItem><Text></Text></StackItem>
              <StackItem> <SquareHintApps20Regular {...primaryIcon} /> </StackItem>
            </Stack>}>
            <Stack tokens={{ childrenGap: 30 }} horizontal>
              <StackItem><Text></Text></StackItem>
              <StackItem> <Caption1 > Discovered Apps </Caption1> </StackItem>
            </Stack>
          </MenuItem>
        </FluentProvider>
      );
  }

  //   if(permissions.includes("all") || permissions.includes("appMonitored_Read") || permissions.includes("appMonitored_Fullaccess") || permissions.includes("appMonitored_ReadandExport"))
  // {
  //   menuItems.push
  //      (
  //        <MenuItem
  //          onClick={() => navigate("/automate/apps/appmonitor")} icon={
  //            <Stack horizontal tokens={{ childrenGap: 40 }}>
  //              <StackItem><Text></Text></StackItem>
  //              <StackItem> <PulseSquare20Regular {...primaryIcon} /> </StackItem>
  //            </Stack>}>
  //          <Stack tokens={{ childrenGap: 30 }} horizontal>
  //            <StackItem><Text></Text></StackItem>
  //            <StackItem> <Caption1 > App&nbsp;Monitored</Caption1> </StackItem>
  //            <StackItem> <Stack tokens={{ childrenGap: 48 }} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>
  //            {/* SPACING IN INLINE SIDEBAR */}
  //          </Stack>
  //        </MenuItem>
  //      );
  // } 


  if (permissions.includes("all") || permissions.includes("appInstall_Read") || permissions.includes("appInstall_Fullaccess") || permissions.includes("appInstall_ReadandExport")) {
    menuItems.push
      (
        <MenuItem onClick={() => navigate("/manage/apps/appinstallstatus")} icon={
          <Stack horizontal tokens={{ childrenGap: 40 }}>
            <StackItem><Text></Text></StackItem>
            <StackItem> <BoxCheckmark20Regular {...primaryIcon} /> </StackItem>
          </Stack>}>
          <Stack tokens={{ childrenGap: 30 }} horizontal>
            <StackItem><Text></Text></StackItem>
            <StackItem> <Caption1> Deploy&nbsp;App&nbsp;Install</Caption1> </StackItem>
            <StackItem> <Stack tokens={{ childrenGap: 40 }} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>
          </Stack>
        </MenuItem>
      );
  }

  if (permissions.includes("all") || permissions.includes("appUnInstall_Read") || permissions.includes("appUnInstall_Fullaccess") || permissions.includes("appUnInstall_ReadandExport")) {
    menuItems.push
      (
        <MenuItem onClick={() => navigate("/manage/apps/appuninstallstatus")} icon={
          <Stack horizontal tokens={{ childrenGap: 40 }}>
            <StackItem><Text></Text></StackItem>
            <StackItem> <UninstallApp20Regular {...primaryIcon} /> </StackItem>
          </Stack>}>
          <Stack tokens={{ childrenGap: 30 }} horizontal>
            <StackItem><Text></Text></StackItem>
            <StackItem> <Caption1 > Deploy&nbsp;App&nbsp;Uninstall </Caption1> </StackItem>
          </Stack>
        </MenuItem>
      );
  }
  if (permissions.includes("all") || permissions.includes("appUnInstall_Read") || permissions.includes("appUnInstall_Fullaccess") || permissions.includes("appUnInstall_ReadandExport")) {
    menuItems.push
      (
        <MenuItem onClick={() => navigate("/manage/apps/appstatus")} icon={
          <Stack horizontal tokens={{ childrenGap: 40 }}>
            <StackItem><Text></Text></StackItem>
            <StackItem> <CheckboxCheckedSync20Regular {...primaryIcon} /> </StackItem>
          </Stack>}>
          <Stack tokens={{ childrenGap: 30 }} horizontal>
            <StackItem><Text></Text></StackItem>
            <StackItem> <Caption1 >Status</Caption1> </StackItem>
          </Stack>
        </MenuItem>
      );
  }


  if (permissions.includes("all") || permissions.includes("appLog_Read") || permissions.includes("appLog_Fullaccess") || permissions.includes("appLog_ReadandExport")) {
    menuItems.push
      (

        <MenuItem onClick={() => navigate("/manage/apps/activitylogg")} icon={
          <Stack horizontal tokens={{ childrenGap: 40 }}>
            <StackItem><Text></Text></StackItem>
            <StackItem> <BookTemplate20Regular {...primaryIcon} /> </StackItem>
          </Stack>}>
          <Stack tokens={{ childrenGap: 30 }} horizontal>
            <StackItem><Text></Text></StackItem>
            <StackItem> <Caption1 > Activity Log </Caption1> </StackItem>
          </Stack>
        </MenuItem>

      );
  }
  //inline side menu content code ends here

  //data table column name code starts here
  var columns = [
    { key: "machine", label: <Caption1> Machine Name </Caption1> },
    { key: "totalDev", label: <Caption1> Size in kb </Caption1> },
    { key: "sizekb", label: <Caption1> Installed Date </Caption1> },
  ];
  //data table column name code ends here
  var columns1 = [
    { key: "machine", label: <Caption1> Machine Name </Caption1> },
    { key: "totalDev", label: <Caption1> Size in kb </Caption1> },
    { key: "sizekb", label: <Caption1> Installed Date </Caption1> },
  ];


  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>

        <Stack tokens={{ childrenGap: 10 }} horizontal>
          <Stack tokens={{ childrenGap: 6 }}>
            <StackItem><Text /></StackItem>
            <StackItem>
              <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={handleRefresh}>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
                  <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                </Stack>
              </Button>
              {/* <CSVLink id="csv-export-link" data={exportData} filename="discoceredappslist.csv">
                <Button shape="circular" appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem>{loading?<ArrowDownload20Regular {...secondaryIcon} />:<ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                  </Stack>
                </Button>
              </CSVLink> */}

              {
                permissions.includes("discoverApps_Fullaccess") || permissions.includes("discoverApps_ReadandExport") ?
                  <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_discoceredappslist.csv`}>
                    <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem>{loading ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                      </Stack>
                    </Button>
                  </CSVLink>
                  :
                  <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                    <Button shape="circular" appearance="subtle" size="small" disabled>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> {loading ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                      </Stack>
                    </Button>
                  </Tooltip>
              }
            </StackItem>
          </Stack>
        </Stack>

          <StackItem grow shrink>
              <Stack horizontalAlign="end">
                  <StackItem grow shrink>
                      <FullScreenButton handle={handle} />
                  </StackItem>
              </Stack>
          </StackItem>
      </>
    ,
  };



  // overflow set contents code ends here
  var tempTableData: any = [];
  var menuLists: any = [];
  var tempExportData: any = [];

  //export pinotAsset data
  // useEffect(() => {
  //   const storedData = JSON.parse(localStorage.getItem('devName') || '{}');
  //   const DevName = storedData.devName;
  //   const appName = storedData.appName;

  //   const fetchData = async () => {
  //     const apiUrl = 'https://pinot-dev.nanoheal.work/sql';

  //     // let sqlQuery = `select v_installedsoftwarenames, v_updateinstallationdate, v_version, siteName, slatest, v_estimatedsizeinkb, machine from t1_d312_singleAsset_v1 where dataid = 36  and siteName= 'Demo_Nanoheal' and v_installedsoftwarenames= '${appName}'`;
  //     let sqlQuery = `SELECT
  //     t1.machine,
  //     t1.slatest,
  //     t1.v_estimatedsizeinkb
  // FROM
  //     t1_d312_installed_software t1
  // WHERE
  //     t1.dataid = 36 AND t1.v_installedsoftwarenames = '${appName}'
  //     AND t1.sitename = 'Nanoheal_Testing'
  //     AND t1.slatest = (
  //         SELECT MAX(t2.slatest)
  //         FROM t1_d312_installed_software t2
  //         WHERE t2.machine = t1.machine
  //     )
  // ORDER BY
  //     t1.v_installedsoftwarenames`;
  //     if (searchVal) {
  //       sqlQuery += ` AND machine LIKE '%${searchVal}%'`;
  //     }
  //     sqlQuery += ' limit 1000';
  //     const requestBody = {
  //       sql: sqlQuery,
  //       trace: false,
  //       queryOptions: "useMultistageEngine=true",
  //     };

  //     const response = await fetch(apiUrl, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(requestBody),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`No result`);
  //     }

  //     const responseData = await response.json();
  //     const rowData = responseData.resultTable.rows;
  //     const uniqueData: any = [];
  //     rowData.forEach((row: any) => {
  //       const isDuplicate = uniqueData.some((existingRow: any) =>
  //         JSON.stringify(existingRow) === JSON.stringify(row)
  //       );
  //       if (!isDuplicate) {
  //         uniqueData.push(row);
  //       }
  //     });

  //     uniqueData !== undefined && uniqueData !== null ? uniqueData.map((data: any, i: any) => {
  //       menuLists.push();
  //       tempExportData.push({
  //         machine: data[0],
  //         totalDev: data[1],
  //         sizekb: data[2],
  //       });
  //     }) : (tempTableData = []);
  //     setTimeout(() => {
  //       setLoading(false);
  //     }, 500);
  //     setExportData(tempExportData);
  //     setData(responseData);
  //   };
  //   fetchData();

  // }, [response, searchVal, setExportData]);

  // useEffect(() => {
  //   //roles and permissions
  //   async function loadRoute() {
  //     console.log("role:-",sessionStorage.getItem('role'))
  //     const role = sessionStorage.getItem('role');

  //     try {
  //       const [routeAllowed, permissions] = await shouldLoadRoute(role);

  //       if (routeAllowed) {
  //         console.log("permission===",permissions);

  //         setPermissions(permissions)
  //       } else {
  //         console.log('Route is not allowed.');
  //       }
  //     } catch (error) {
  //       console.error('Error loading route:', error);
  //     }
  //   }

  //   loadRoute();
  // }, []);


  //pinotable data over here
  useEffect(() => {

    const storedData = JSON.parse(localStorage.getItem('devName') || '{}');
    const DevName = storedData.devName;
    const appName = storedData.appName;

    const fetchData = async () => {
      try {
        const apiUrl = 'https://pinot-dev.nanoheal.work/sql';
        let whereCondition: any = '';
        if (searchVal) {
          whereCondition += ` AND machine LIKE '%${searchVal}%'`;
        }
        // let sqlQuery = `select v_installedsoftwarenames, t1.v_estimatedsizeinkb, v_updateinstallationdate, v_version, siteName, slatest, v_estimatedsizeinkb, machine from t1_d312_singleAsset_v1 where dataid = 36  and siteName= 'Demo_Nanoheal' and v_installedsoftwarenames= '${appName}'`;

        // let sqlQuery = `SELECT\n  t1.machine,\n  t1.slatest,\n t1.v_estimatedsizeinkb\nFROM\n  t1_d312_installed_software t1\nWHERE\n  t1.dataid = 36\n  AND t1.siteName = 'Demo_Nanoheal'\n AND t2.v_installedsoftwarenames = '${appName} AND t1.slatest = (\n    SELECT MAX(t2.slatest)\n    FROM t1_d312_installed_software t2\n    WHERE t2.machine = t1.machine\n'\n  )\nORDER BY\n  t1.v_installedsoftwarenames`;
        let sqlQuery = `SELECT
        t1.machine,
        t1.slatest,
        t1.v_estimatedsizeinkb
    FROM
        t1_d312_installed_software t1
    WHERE
        t1.dataid = 36 AND t1.v_installedsoftwarenames = '${appName}'
        AND t1.sitename = 'Demo_Nanoheal'
        ${whereCondition}
        AND t1.slatest = (
            SELECT MAX(t2.slatest)
            FROM t1_d312_installed_software t2
            WHERE t2.machine = t1.machine
            AND t2.v_installedsoftwarenames = t1.v_installedsoftwarenames
        )
    ORDER BY
        t1.v_installedsoftwarenames`;

        sqlQuery += ' limit 1000';

        const requestBody = {
          sql: sqlQuery,
          trace: false,
          queryOptions: "useMultistageEngine=true",
        };

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`No result`);
        }

        const responseData = await response.json();
        const rowData = responseData.resultTable.rows;

        const uniqueData: any = [];
        rowData.forEach((row: any) => {
          const isDuplicate = uniqueData.some((existingRow: any) =>
            JSON.stringify(existingRow) === JSON.stringify(row)
          );
          if (!isDuplicate) {
            uniqueData.push(row);
          }
        });

        const startIndex = ((currentPageNo - 1) * 50) + 1;
        const endIndex = currentPageNo * 50;
        const currentPageData = uniqueData

        currentPageData.forEach((data: any, i: any) => {
          tempTableData.push({
            checkbox: "hide",
            machine: { label: <Caption1> {data[0]}  </Caption1>, id: `${i}` },
            sizekb: { label: <Caption1> {data[1]} </Caption1> },
            totalDev: { label: <Caption1> {data[2]} </Caption1> },
          });
        });

        setTotalRecords(rowData.length);
        setTotalPages(Math.ceil((rowData.length) / 50));
        setTableData(tempTableData);
        setData(responseData);
        setLoading(false);
        setRefreshing(false); // Reset refreshing state after data is fetched
      } catch (error) {
        setError('No result.');
        setLoading(false);
        setRefreshing(false); // Reset refreshing state in case of error
      }
    };
    fetchData();

  }, [response, searchVal, refreshing, permissions]);


  // if (loading) return <p>Loading... </p>;
  // if (loading) return <SkeletonContent />;
  // if (error) return <p>Error: {error}</p>;


  // data table values append code ends here
  var overLayData: any = {
    headerTitle: "Temp File Clean Up",
    size: "large",
    isTabs: true,
    tabItems: {
      Introduction:
        <>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            Introduction
          </Stack>
        </>,

      Configuration:
        <>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            Configuration
          </Stack>
        </>,
    },
  };

  const DismissButton: React.FC<ButtonProps> = (props) => {
    return (
      <Button shape="circular"
        onClick={() => setSearchVal('')}
        {...props}
        appearance="transparent"
        icon={<Dismiss16Regular />}
        size="small"
      />
    );
  };

  return (
    <FullScreen handle={handle} className="fullScreenBackgroundColor">
      <StackItem grow shrink style={BreadcrumbsBorder}>
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          <StackItem grow shrink>
            <Stack horizontalAlign="start" tokens={{ childrenGap: 5 }}>
              <StackItem><Text></Text></StackItem>
              <StackItem grow shrink>
                <Breadcrumbs
                  items={[
                    { name: "Apps", link: "#" },
                    { name: "Discover Apps", link: "/manage/apps/discoveredapps" },
                    { name: "Discovered Apps Details", link: "#" }
                  ]}
                />
              </StackItem>
            </Stack>
          </StackItem>
        </Stack>
      </StackItem>
      <FluentProvider style={SubSectionResponsive} theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 20 }} horizontal style={DynamicBoxingCSS}>
          <StackItem style={DynamicBoxingCSS}>
            <StackItem style={DynamicBoxingCSS}>
              <Stack style={DynamicBoxingCSS}>
                {/* <Stack tokens={{ childrenGap: 20 }}><StackItem><Text /></StackItem><StackItem><Text /></StackItem></Stack> */}
                <Stack horizontal style={parentHome}> {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={menuItems} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={DynamicBoxingCSS} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem style={wraperStyle}>
                        <Stack wrap horizontal horizontalAlign="space-between">
                          <Stack horizontal tokens={{ childrenGap: 20 }}>
                            <StackItem>
                            <SearchBox onChange={(e: any) => { setSearchVal(e.target.value); }} value={searchVal} placeholder="Search" size="small" dismiss={null} contentAfter={<DismissButton aria-label="Clear" />} />
                            </StackItem>
                            <StackItem>
                              <MenuDropdown open={filterMenuOpen} btn={
                                <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <FilterAdd20Filled {...primaryIcon} />
                                    <Body1> Filter </Body1>
                                  </Stack>
                                </MenuButton>
                              } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                <Divider />
                                <MenuList>
                                  <Stack tokens={{ childrenGap: 5 }}>
                                    <StackItem> <Text></Text> </StackItem>
                                    <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                    <DropdownComponent optionData={columns1} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                    <StackItem> <Divider /> </StackItem>
                                    <StackItem> <Caption1> Value </Caption1> </StackItem>
                                    <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />
                                    <StackItem> <Divider /> </StackItem>
                                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                                      <StackItem> <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false) }}> <Caption1> Apply </Caption1> </Button> </StackItem>
                                      <StackItem> <Button shape="circular" onClick={() => setFilterMenuOpen(false)}> <Caption1> Cancel </Caption1> </Button> </StackItem>
                                    </Stack>
                                  </Stack>
                                </MenuList>
                              </>} />
                            </StackItem>
                            <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                              <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                  <StackItem> <FilterDismiss20Filled /> </StackItem>
                                  <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                </Stack>
                              </Button>
                            </StackItem>
                          </Stack>
                          {tableData?.length > 0 &&
                            <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>
                          }
                        </Stack>
                        <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                        {tableData.length > 0 && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                          <StackItem> {totalRecords > 0 && <Caption1>  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
                        </Stack>}
                      </StackItem>
                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (
                        <DataTable tableData={tableData} columns={columns}></DataTable>
                      ) : (
                        <Stack> <StackItem> </StackItem>
                          <StackItem> No results found </StackItem>
                        </Stack>
                      )}
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>
              <OverLay
                overlayopen={overlayOpen}
                setOverlayOpen={setOverlayOpen}
                overlayData={overLayData}
              />
            </StackItem>
          </StackItem>
          <StackItem><Text /></StackItem>
        </Stack>
      </FluentProvider>
    </FullScreen>
  );
};